import { SVGProps } from "react"
const LandingEmailIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M11.5998 14.3996H4.3998C2.2398 14.3996 0.799805 13.2702 0.799805 10.6349V5.36432C0.799805 2.72902 2.2398 1.59961 4.3998 1.59961H11.5998C13.7598 1.59961 15.1998 2.72902 15.1998 5.36432V10.6349C15.1998 13.2702 13.7598 14.3996 11.5998 14.3996Z"
      fill="currentColor"
    />
    <path
      d="M11.3337 6L9.24699 7.66667C8.56032 8.21333 7.43366 8.21333 6.74699 7.66667L4.66699 6"
      stroke="var(--comp-bg, white)"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default LandingEmailIcon
